import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=73138a9c"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=73138a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports